import React from "react";
import { Container, Header, Schools, School, Title, Grades, Distance } from "./styled/listing-schools";
function ListingSchools(_a) {
    var _b = _a.schools, schools = _b === void 0 ? [] : _b;
    if (!schools.length)
        return null;
    return (React.createElement(Container, null,
        React.createElement(Header, null, "Schools"),
        React.createElement(Schools, null, schools.map(function (_a, index) {
            var title = _a.title, grades = _a.grades, distance = _a.distance;
            return (React.createElement(School, { key: index },
                React.createElement(Title, null,
                    React.createElement("strong", null, title)),
                React.createElement(Grades, null, grades),
                React.createElement(Distance, null, distance)));
        }))));
}
export default ListingSchools;
